import {
  Container,
  ImageContainer,
  Images,
  Paragraph,
  Section,
  Text,
  Title,
} from "./style/style";
import { EventosImage } from "./images";

function Eventos() {
  return (
    <Container>
        <Title>
            Uma história pode se iniciar aqui
        </Title>
      <Section>
        {EventosImage.map(({ title, information, data, image, id }) => {
          return (
            <div key={id}>
              <ImageContainer>
                <Text>
                  <Title>{title}</Title>
                  <Paragraph>
                    {information} <br /> <br />
                    {data}
                  </Paragraph>
                </Text>
                <hr className="hr" />
                <Images>
                  <img
                    src={image.src}
                    alt={image.alt}
                    style={{ width: image.width, height: image.heigth }}
                  />
                </Images>
              </ImageContainer>
            </div>
          );
        })}
      </Section>
    </Container>
  );
}
export default Eventos;
